import { render, staticRenderFns } from "./layoutFull.vue?vue&type=template&id=2591f8a4&scoped=true"
import script from "./layoutFull.vue?vue&type=script&lang=js"
export * from "./layoutFull.vue?vue&type=script&lang=js"
import style0 from "./layoutFull.vue?vue&type=style&index=0&id=2591f8a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2591f8a4",
  null
  
)

export default component.exports